import { foundation } from '../../ui';
import { injectSkeletonKeyframes } from './skeletonMotion';

/**
 * @param {'shimmer' | 'pulse'} [variant] — shimmer default (atlas); pulse for legacy spots.
 */
export default function Skeleton({
  width = '100%',
  height = '20px',
  borderRadius = foundation.radii.sm,
  variant = 'shimmer',
  style: override,
}) {
  injectSkeletonKeyframes();
  const className = variant === 'pulse' ? 'cvx-skeleton-pulse' : 'cvx-skeleton-shimmer';
  return (
    <div
      className={className}
      style={{
        width,
        height,
        borderRadius,
        flexShrink: 0,
        ...override,
      }}
      aria-hidden
    />
  );
}
